/* eslint-disable*/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import MultiplasAtividades from '../templates/MultiplasAtividades';
import { doGet, validateObject, trataMensagensErro } from '../../../utils/requests';
import validarCNPJ from '../../../utils/validator/cnpjValidator';
import { stringToData } from '../../../utils/helpers';
import {
  recuperarAnosQuePossuemAlgumaRemuneracao,
  calcularTotal,
  calcularTotalAfastamentos,
} from '../../../utils/ctcHelpers';
import ModalAtividade from './ModalAtividade';
import * as listUtils from '../../../utils/listsSelect';

const VAZIO = '';
const QTD_MAXIMA_ANOS_POR_ATIVIDADE = 60;

class CtcAtividade extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState(props);
  }

  getInitialState = () => ({
    ctcAtividade: {
      cnpj: null,
      nomeEmpregador: null,
      cargo: null,
      dtInicio: null,
      dtFim: null,
      diasContribuicaoBruto: null,
      alunoAprendiz: 0,
      ctpsNumero: null,
      ctpsSerie: null,
      afastamentos: [],
      temposCertificados: [],
      temposEspeciais: [],
      remuneracoes: [],
      pertenceSegundaMatricula: null,
    },
    validadeCampos: {
      cargo: false,
      dtInicio: false,
      dtFim: false,
      temposCertificados: false,
      pertenceSegundaMatricula: false,
    },
    remuneracoesAtividade: {
      totalizadorAnos: null,
      anos: [],
      moedasCompetencia: [],
      competenciasInicio: [],
    },
    exibirBotaoIncluirInicial: false,
    estadoFormulario: 'inicial',
    subEstadoFormulario: 'incluir-atividade',
    desabilitarCamposIncluirAtividade: true,
    tituloBotao: 'Salvar atividade',
    desabilitarBotaoAlterar: null,
    desabilitarListaBotoes: null,
    showModal: false,
    touched: false,
    anosQuePossuemAlgumaRemuneracao: [],
    requestPesquisa: null,
    // remuneracoesHistory: [],
    dataInicioAtividadeMenorQue1994: false,
    dataFimAtividadeMenorQue1994: false,
  });

  componentDidMount() {
    this.atualizarEstadoFormulario();
  }

  atualizarEstadoFormulario = () => {
    const acaoPrincipal = this.props.statePrincipal.acao;
    let retorno = 'incluir';
    switch (acaoPrincipal) {
      case 'novo':
          retorno = 'incluir';
        break;
      //case 'alterar-ctc':
      case 'editar-rascunho':
          retorno = 'alterar';
        break;
      default: 
        break;
    }
    let {estadoFormulario} = {...this.state};
    estadoFormulario = retorno;
    this.setState({
      estadoFormulario,
    }, this.verificarExibicaoBotaoInclusaoInicial());
  }

  verificarExibicaoBotaoInclusaoInicial = () => {
    const { acao } = { ...this.props.statePrincipal };
    const { estadoFormulario } = { ...this.state };

    switch (acao) {
      case 'novo':
        if (estadoFormulario === 'incluir') {
          this.setState({
            exibirBotaoIncluirInicial: true,
          });
        }
        if (estadoFormulario === 'inicial') {
          this.setState({
            exibirBotaoIncluirInicial: true,
          });
        }
        break;
      case 'editar-rascunho':
        const exibirPainel = this.props.statePrincipal.exibirPainelAtividades;
        if (!exibirPainel) {
          this.setState({
            exibirBotaoIncluirInicial: true,
          });
        }
        break;
      case 'detalhar-ctc':
        this.setState({
          exibirBotaoIncluirInicial: false,
        });
        break;
      case 'revisar-ctc':
        if (estadoFormulario === 'inicial') {
          this.setState({
            exibirBotaoIncluirInicial: true,
          });
        }        
        break;  
      default:
        break;
    }
  }

  recuperarMatriculaEscolhidaNaCombo = (lista, pertenceSegundaMatricula) => {
    let matricula1Combo = '';
    let matricula2Combo = '';
    let retorno = '';
    const tamanho = lista.length;
    
    if (tamanho === 0) {
      const { matricula1 } = { ...this.props.statePrincipal.ctc };
      matricula1Combo = matricula1;
    } else {
      if (tamanho === 1) {
        matricula1Combo = lista[0].label.split('-')[0].trim();
      }
      if (tamanho === 2) {
        matricula1Combo = lista[0].label.split('-')[0].trim();
        matricula2Combo = lista[1].label.split('-')[0].trim();
      }
    }

    // se o atributo pertenceSegundaMatricula é null, quer dizer que pertence a primeira matricula.
    if (pertenceSegundaMatricula !== null && Number(pertenceSegundaMatricula) === 0 || (pertenceSegundaMatricula === null)) {
      retorno = matricula1Combo;
    } else {
      retorno = matricula2Combo;
    }
    return retorno;
  }

  determinarConcomitancias = (atividades, novaAtividade) => {
    let pertenceAMesmaMatricula = false;
    const {listaMatriculasCadastradas} = { ...this.props.statePrincipal };
    let matriculaUtilizada = this.recuperarMatriculaEscolhidaNaCombo(listaMatriculasCadastradas, novaAtividade.pertenceSegundaMatricula);

    let atividadeExistenteConcomitante;
    let temConcomitancia = false;
    for (let i = 0, tamanhoI = atividades.length; i < tamanhoI; i += 1)  {
      if (novaAtividade.indice != i  ) {
        let atividadeAux = atividades[i];
        if (stringToData(novaAtividade.dtInicio) <= stringToData(atividadeAux.dtFim) && 
        stringToData(atividadeAux.dtInicio) <= stringToData(novaAtividade.dtFim) && atividadeAux.matricula === matriculaUtilizada) {
          temConcomitancia = true;
          atividadeExistenteConcomitante = atividadeAux;
        }         
      }
    }   
    if (temConcomitancia) {
      if (((novaAtividade.pertenceSegundaMatricula === null || Number(novaAtividade.pertenceSegundaMatricula) === 0) ||
      (novaAtividade.pertenceSegundaMatricula === 1)) &&
      atividadeExistenteConcomitante.matricula === matriculaUtilizada) {
        pertenceAMesmaMatricula = true;
      }
      if (pertenceAMesmaMatricula && (temConcomitancia)) { 
        return true;
      }
    }
    return false;
  }

  atualizarEstadoFormulario = () => {
    const acaoPrincipal = this.props.statePrincipal.acao;
    let retorno = 'incluir';
    switch (acaoPrincipal) {
      case 'novo':
          retorno = 'incluir';
        break;
      //case 'alterar-ctc':
      case 'editar-rascunho':
          retorno = 'alterar';
        break;
      default: 
        break;
    }
    let {estadoFormulario} = {...this.state};
    estadoFormulario = retorno;
    this.setState({
      estadoFormulario,
    }, this.verificarExibicaoBotaoInclusaoInicial());
  }

  guardarAtividadeTemporaria = (ctcAtividade) => {
    const {acao} = { ...this.props.statePrincipal };
    if(acao === 'novo') {
      // HANDLECHANGE DO RepositorioCTC
      this.props.handleChange({ value: ctcAtividade, isValid: true }, 'atividadeTemporaria');
    }
  }

  handleChange = (changeObj, name) => {
    let valor = changeObj.value;
    let { ctcAtividade } = { ...this.state };
    if (['anosQuePossuemAlgumaRemuneracao', 'showModal',
      'exibirBotaoIncluirInicial', // 'remuneracoesHistory',
      'dataInicioAtividadeMenorQue1994', 'dataFimAtividadeMenorQue1994'].includes(name)) {
      this.setState({
        [name]: valor,
      });
    } else {
      if (['afastamentos', 'temposEspeciais', 'remuneracoes'].includes(name)) {
        this.setState({
          ctcAtividade: {
            ...ctcAtividade,
            [name]: valor,
          },          
        }, this.guardarAtividadeTemporaria(ctcAtividade));
      } else {
        this.setState({
          ctcAtividade: {
            ...ctcAtividade,
            [name]: valor,
          },
          validadeCampos: {
            ...this.state.validadeCampos,
            [name]: changeObj.isValid,
          },
        }, this.guardarAtividadeTemporaria(ctcAtividade));
      }
    }
  }

  formularioProntoParaEnvio = () => {
    return validateObject(this.state.validadeCampos); 
  }

  limparValidadeCampos = () => {  
    const limparValidadeCampos = {
      cargo: false,
      dtInicio: false,
      dtFim: false,
      temposCertificados: false,
      pertenceSegundaMatricula: false,
    }
    this.setState({
      validadeCampos: limparValidadeCampos,
    });
  }

  resetarValidadeCampos = () => {
    const validadeCamposReset = {
      cargo: false,
      dtInicio: false,
      dtFim: false,
      // diasContribuicaoBruto: false,
      temposCertificados: false,
      pertenceSegundaMatricula: false,
    }
    this.setState({
      validadeCampos: validadeCamposReset,
    }, this.resetarEstadoFormulario());
  }

  resetarObjetoAtividade = () => {
    const atividadeReset = {
      cnpj: VAZIO,
      nomeEmpregador: VAZIO,
      cargo: VAZIO,
      dtInicio: VAZIO,
      dtFim: VAZIO,
      diasContribuicaoBruto: VAZIO,
      alunoAprendiz: null,
      ctpsNumero: VAZIO,
      ctpsSerie: VAZIO,
      afastamentos: [],
      temposCertificados: [],
      temposEspeciais: [],
      remuneracoes: [],
      pertenceSegundaMatricula: null,
    };
    this.setState({
      ctcAtividade: atividadeReset,
    }, this.resetarValidadeCampos);
  }

  resetarExibirBotaoIncluirInicial = () => {
    const exibirBotaoIncluir = !['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao);
    this.setState({
      exibirBotaoIncluirInicial: exibirBotaoIncluir,
    }, this.props.habilitarLinhasDestinacao);

  }

  resetarEstadoFormulario = () => {
    const { acao } = { ...this.props.statePrincipal };
    let estado = null;
    let subEstado = 'incluir-atividade'

    switch (acao) {
      case 'novo':
        estado = 'incluir';
        break;
      default:
      break;
      case 'editar-rascunho':
        estado = 'alterar';
        break;
    }
  
    this.setState({
      estadoFormulario: estado,
      subEstadoFormulario: subEstado,
    }, this.resetarExibirBotaoIncluirInicial);
  }

/**
 * @todo revisar esse método
 */

  atualizarValidadeCampos = () => {
    const { atividades } = { ...this.props.statePrincipal.ctc };
    let existeTempoCertificado = false;
    // let existeMatriculaSelecionada = false;

    if (atividades !== null && atividades.length > 0) {
      atividades.forEach((atividade) => {
        if(atividade.temposCertificados && atividade.temposCertificados.length > 0) {
          existeTempoCertificado = true;
        }
      });
    }
    this.validarCheckboxSegundaMatricula();
    this.setState({
      validadeCampos: {
        ...this.state.validadeCampos,
        temposCertificados: existeTempoCertificado,
        pertenceSegundaMatricula: true,
      },
    });
  }

  validarCnpj = cnpj => (
    validarCNPJ(cnpj)
  )

  verificarTamanhoListaTemposCertificados = (atividades) => {
    let retorno = false;
    atividades.forEach((atividade) => {
      if(atividade.temposCertificados && atividade.temposCertificados.length > 0) {
        retorno = true;
      } else {
        retorno = false;
      }
    });
    return retorno;
  }

  /*
    Apresentar o tempo líquido em dias, calculado da seguinte forma: 
    quantidade de dias corridos entre a data fim e a data de início de tempos certificados inclusive,
    menos a quantidade de dias de afastamento.
  */

  //| dataInicio  afastamento.dtInicio  afastamento.dtFim  dataFim |
  calcularTempoLiquidoCertificado = (dataInicio, dataFim, retornarValor, listaAfastamentos) => {
    let total = 0;
    let totalAfastamentos = 0;
    let retorno = 0;
    let { temposCertificados, afastamentos } = { ...this.state.ctcAtividade };
    const {ctcAtividade} = { ...this.state };

    if ((afastamentos && afastamentos.length === 0) && (listaAfastamentos && (listaAfastamentos !== null && listaAfastamentos.length > 0))) {
      afastamentos = listaAfastamentos;
    } else if (afastamentos === null && listaAfastamentos === null) {
      afastamentos = [];
    }

    if ((dataInicio !== undefined && dataInicio !== null && dataInicio !== '') &&
    (dataFim !== undefined && dataFim !== null && dataFim !== '')) {
      totalAfastamentos = calcularTotalAfastamentos(dataInicio, dataFim, afastamentos);
      total = calcularTotal(dataInicio, dataFim);
    }
    retorno = (total - totalAfastamentos);

    if (retornarValor) {
      return retorno;
    } else {
      const index = temposCertificados.findIndex(tempo => (tempo.dtInicio === dataInicio && tempo.dtFim === dataFim));
      if (index !== -1) {
        temposCertificados[index].tempoLiquidoCertificado = retorno;
      }
      this.setState({
        ctcAtividade: {
          ...ctcAtividade,
          temposCertificados,
        },
      });
    }
  }
  // Método usado quando a tab Tempos certificados é clicada.
  verificarMudancaTempoLiquidoCertificado = () => {
    let { temposCertificados} = { ...this.state.ctcAtividade };
      temposCertificados = this.ordenarLista(temposCertificados);
      temposCertificados.forEach((tempoCertificado) => {
        this.calcularTempoLiquidoCertificado(tempoCertificado.dtInicio, tempoCertificado.dtFim, false, null);
      });
  }

  handleManterAtividade = () => {
    let { atividades } = { ...this.props.statePrincipal.ctc };
    const { ctc } = {...this.props.statePrincipal};
    let temConcomitancia = false ;
    let atividadeDentroDoPeriodoDeContribuicao = false;
    const cnpjValido = this.validarCnpj(this.state.ctcAtividade.cnpj);
    let existeTempoCertificado = false;
    const { ctcAtividade } = { ...this.state };
    if (cnpjValido === false) {
      trataMensagensErro(['CNPJ Inválido. Informe um CNPJ válido.']);
    } else {
      if (!atividades) {
        atividades = [];
      }
      temConcomitancia = this.tratarConcomitanciaAtividade();
      atividadeDentroDoPeriodoDeContribuicao = this.isAtividadeDentroDoPeriodoDeContribuicao(ctcAtividade, ctc);
      if (!temConcomitancia && atividadeDentroDoPeriodoDeContribuicao) {
        if (this.state.subEstadoFormulario === 'alterar-atividade') {
          let index = -1;
          index = atividades.findIndex(periodo => (periodo.dtInicio === ctcAtividade.dtInicio &&
            periodo.dtFim === ctcAtividade.dtFim &&
            periodo.matricula === ctcAtividade.matricula));
          if (index !== -1) {
            atividades[index] = ctcAtividade;
          } else {
            index = atividades.findIndex(periodo => (periodo.indice === ctcAtividade.indice));
            atividades[index] = ctcAtividade;
          }
        } else {
          atividades.push(ctcAtividade);
        }
        this.props.handleChange({ value: atividades, isValid: atividades.length > 0 }, 'atividades');
        existeTempoCertificado = this.verificarTamanhoListaTemposCertificados(atividades);        
        this.calcularTempoLiquidoCertificado(ctcAtividade.dtInicio, ctcAtividade.dtFim, false, null);
        this.resetarObjetoAtividade();
        this.verificarDesabilitarTodosOsBotoesAlterar(false);
        this.setState({
          desabilitarBotaoAlterar: null,
          exibirBotaoIncluirInicial: true,
          subEstadoFormulario: 'incluir-atividade',
          validadeCampos: {
            ...this.state.validadeCampos,
            temposCertificados: existeTempoCertificado,
          },
        }, () => this.showModalAtividade());  
      }
    }
  }

  exibirMatriculaConcomitante = (pertenceSegundaMatricula) => {
    let retorno = '';
    let { ctc } = { ...this.props.statePrincipal };
    if (pertenceSegundaMatricula && Number(pertenceSegundaMatricula) === 1) {
      retorno = ctc.matricula2;
    } else {
      retorno = ctc.matricula1;
    }
    return retorno;
  }

  tratarConcomitanciaAtividade = () => {
    let { atividades } = { ...this.props.statePrincipal.ctc };
    const { ctcAtividade } = { ...this.state };
    let temConcomitancia = false;
    if(atividades && (atividades !== null && atividades.length > 0)) {
      // const copiaAtividades = ctcAtividade;
      //atividades = this.ordenarLista(atividades);
      temConcomitancia = this.determinarConcomitancias(atividades, ctcAtividade);
      if (temConcomitancia) {
        // if (this.state.subEstadoFormulario === 'alterar-atividade') {
        //   atividades[ctcAtividade.indice] = copiaAtividades;
        //   } else {
        //   const index = pesquisarIndice(atividades, undefined);
        //   if (index !== -1) {
        //     atividades.splice(index, 1);
        //   }
        // }
        let matriculaConcomitante = this.exibirMatriculaConcomitante(ctcAtividade.pertenceSegundaMatricula);
        trataMensagensErro([`A atividade do período de ${ctcAtividade.dtInicio} até ${ctcAtividade.dtFim}
          é concomitante com outra atividade pertencente à matrícula ${matriculaConcomitante}.`]);
      }
    }
    return temConcomitancia;
  }

  isAtividadeDentroDoPeriodoDeContribuicao = (atividade, ctc) => {
    let matriculaSelecionada = '';
    let dtAdmissao = '';
    let dtDemissao = '';
    let pertenceASegundaMatricula = null;

    if(atividade.pertenceSegundaMatricula !== null) {
      pertenceASegundaMatricula = Number(atividade.pertenceSegundaMatricula);
    }
    if (pertenceASegundaMatricula === null || pertenceASegundaMatricula === 0) {
      matriculaSelecionada = ctc.matricula1;
      dtAdmissao = ctc.dtAdmissaoMat1;
      dtDemissao = ctc.dtDemissaoMat1;
    } else {
      matriculaSelecionada = ctc.matricula2;
      dtAdmissao = ctc.dtAdmissaoMat2;
      dtDemissao = ctc.dtDemissaoMat2;
    }

    const item = {
      'matricula': matriculaSelecionada,
      'dtAdmissaoMatricula': dtAdmissao,
      'dtDemissaoMatricula': dtDemissao,
      'dtInicioAtividade': atividade.dtInicio,
      'dtFimAtividade': atividade.dtFim,
    };
    let atividadeDentroDoPeriodoDaMatricula = true;
    if(item.dtAdmissaoMatricula !== null && item.dtDemissaoMatricula !== null) {
      atividadeDentroDoPeriodoDaMatricula = this.compararDatasAtividadeComPeriodoAtivoDaMatricula(item);
      if (atividadeDentroDoPeriodoDaMatricula === false) {
        trataMensagensErro([`A atividade do período de ${item.dtInicioAtividade} até ${item.dtFimAtividade}
          não está contida no periodo ativo da matrícula ${item.matricula}`]);
      }
    }
    return atividadeDentroDoPeriodoDaMatricula;
  }

  calcularDiasContribuicaoBrutoAtividade = (atividade) => {
    let { ctcAtividade } = { ...this.state };
    let retorno = '';
    if (atividade) {
      ctcAtividade = atividade;
    }
    if (ctcAtividade) {
      if ((ctcAtividade.dtInicio && (ctcAtividade.dtInicio !== VAZIO && ctcAtividade.dtInicio.indexOf('_') === -1)) && 
        (ctcAtividade.dtFim && (ctcAtividade.dtFim !== VAZIO && ctcAtividade.dtFim.indexOf('_') === -1))) {
        const data1 = moment(ctcAtividade.dtInicio , 'DD/MM/YYYY');
        const data2 = moment(ctcAtividade.dtFim , 'DD/MM/YYYY');
        // const diferenca = data2.diff(data1, 'days');
        // const qtdDiasContribuicaoBruto = (Number(diferenca) + 1);
        // retorno = this.validarTotalDiasBrutoAtividade(qtdDiasContribuicaoBruto, ctcAtividade.diasContribuicaoBruto);
        retorno = (data2.diff(data1, 'days') + 1);
      }
      this.setState({
          ctcAtividade: {
            ...ctcAtividade,
            diasContribuicaoBruto: retorno,
          },
        // validadeCampos: {
        //   ...this.state.validadeCampos,
        // },
      });
    }
  }

  validarDatasInicioEFimAtividade = (atividade) => {
    let { ctcAtividade } = { ...this.state };
    let retorno = false;
    const dataAtual = new Date();
    if (atividade) {
      ctcAtividade = atividade;
    }

    if (ctcAtividade) {
      if ((ctcAtividade.dtInicio && (ctcAtividade.dtInicio !== VAZIO && ctcAtividade.dtInicio.indexOf('_') === -1)) &&
      (ctcAtividade.dtFim && (ctcAtividade.dtFim !== VAZIO && ctcAtividade.dtFim.indexOf('_') === -1))) {
        if (moment(ctcAtividade.dtInicio, 'DD/MM/YYYY').toDate() > moment(ctcAtividade.dtFim, 'DD/MM/YYYY').toDate()) {
          trataMensagensErro(['O período é inválido. A data de início de período deve ser menor que a data de fim do período.']);
          retorno = false;
        } else if (moment(ctcAtividade.dtFim, 'DD/MM/YYYY').toDate() > dataAtual) {
          trataMensagensErro(['O período é inválido. A data de fim de período não deve ser maior que a data atual.']);
          retorno = false;
        } else {
          retorno = true;
        }
        this.calcularDiasContribuicaoBrutoAtividade(ctcAtividade);
      }
      this.setState({
        validadeCampos: {
          ...this.state.validadeCampos,
          dtInicio: retorno,
          dtFim: retorno,
        },
    }, this.verificarTotalAnosAtividade(ctcAtividade.dtInicio, ctcAtividade.dtFim));
    }
  }

  exibirComboMatriculasCadastradas = () => {
    let { ctc } = { ...this.props.statePrincipal };
    const checkboxMarcado = this.props.statePrincipal.informarSegundaMatricula === 1;
    const temMatricula1 = (ctc.matricula1 !== null && ctc.matricula1 !== VAZIO);
    const temMatricula2 = (ctc.matricula2 !== null && ctc.matricula2 !== VAZIO);
    let retorno = false;

    if (checkboxMarcado && temMatricula1 && temMatricula2) {
      retorno = true;
    }
    return retorno;
  }

  recuperarNomeDestinacao = (indice) => {
    let { destinacoes } = { ...this.props.statePrincipal.ctc };
    let nome = VAZIO;
    const index = destinacoes.findIndex(dest => (dest.indiceDestinacao === indice));
    if (index !== -1) {
      nome = destinacoes[index].nomeParticipante;
    }
    return nome;
  }

  formatarMoeda = (valor) => {
    if (typeof (valor) !== 'number') {
      let aux = valor;
      aux = valor.replace(/\./g, '').replace(/,/g, '.');
      return Number(aux);
    }
    return valor;
  }

  carregarListaDeAnosComRemuneracoes = (atividades) => {
    let { anosQuePossuemAlgumaRemuneracao } = { ...this.state };
    let remuneracoes = this.ordenarCompetenciasRemuneracao(atividades.remuneracoes);
    if (remuneracoes.length > 0) {
      remuneracoes.forEach((remuneracao) => {        
        let anoCompetencia = null;        
        anoCompetencia = remuneracao.ano;        
        const indiceAno = anosQuePossuemAlgumaRemuneracao.findIndex(a => (a.ano === anoCompetencia));
        if (indiceAno === -1) {
          const ano = {
            ano: anoCompetencia,
          }
          anosQuePossuemAlgumaRemuneracao.push(ano);
        }
      });
      anosQuePossuemAlgumaRemuneracao = recuperarAnosQuePossuemAlgumaRemuneracao(anosQuePossuemAlgumaRemuneracao, remuneracoes);
      this.ordenarRemuneracoesPorAno(anosQuePossuemAlgumaRemuneracao);
      this.setState({
        anosQuePossuemAlgumaRemuneracao
      });
    }
  }

  calcularTempoAfastamento = (dataInicio, dataFim) => {
    let total = 0;
    if ((dataInicio !== undefined && dataInicio !== null && dataInicio !== '') && (dataFim !== undefined && dataFim !== null && dataFim !== '')) {
      const inicio = moment(dataInicio, 'DD/MM/YYYY').toDate();
      const fim = moment(dataFim, 'DD/MM/YYYY').toDate();
      total = (moment(fim).diff(inicio, 'days') + 1);
    }
    return total;
  }

  calcularTempoEspecial = (dataInicio, dataFim) => {
    let total = 0;
    if ((dataInicio !== undefined && dataInicio !== null && dataInicio !== '') && (dataFim !== undefined && dataFim !== null && dataFim !== '')) {
      const inicio = moment(dataInicio, 'DD/MM/YYYY').toDate();
      const fim = moment(dataFim, 'DD/MM/YYYY').toDate();
      total = (moment(fim).diff(inicio, 'days') + 1);
    }
    return total;
  }

  handleCarregarAlteracaoAtividade = (row) => {
    let { atividades } = { ...this.props.statePrincipal.ctc };
    let { validadeCampos } = { ...this.state };
    let ctcAtividade = {
      cnpj: atividades[row].cnpj,
      nomeEmpregador: atividades[row].nomeEmpregador,
      cargo: atividades[row].cargo,
      dtInicio: atividades[row].dtInicio,
      dtFim: atividades[row].dtFim,
      diasContribuicaoBruto: atividades[row].diasContribuicaoBruto,
      alunoAprendiz: atividades[row].alunoAprendiz,
      ctpsNumero: atividades[row].ctpsNumero,
      ctpsSerie: atividades[row].ctpsSerie,
      afastamentos: atividades[row].afastamentos,
      temposCertificados: atividades[row].temposCertificados,
      temposEspeciais: atividades[row].temposEspeciais,
      remuneracoes: atividades[row].remuneracoes,
      indice: atividades[row].indice,
      idAtividade: atividades[row].idAtividade,
      pertenceSegundaMatricula: atividades[row].pertenceSegundaMatricula,
      matricula: atividades[row].matricula,
    }
    if (ctcAtividade.cargo !== null && ctcAtividade.cargo !== VAZIO) {
      validadeCampos.cargo = true;
    }
    if (ctcAtividade.dtInicio !== null && ctcAtividade.dtInicio !== VAZIO) {
      validadeCampos.dtInicio = true;
    }
    if (ctcAtividade.dtFim !== null && ctcAtividade.dtFim !== VAZIO) {
      validadeCampos.dtFim = true;
    }
    if (ctcAtividade.diasContribuicaoBruto !== null && ctcAtividade.diasContribuicaoBruto !== VAZIO) {
      validadeCampos.diasContribuicaoBruto = true;
    }
    
    if (ctcAtividade.afastamentos && ctcAtividade.afastamentos.length > 0) {
      ctcAtividade.afastamentos.map((item) => {
        const itemIndexado = item;
        itemIndexado.tempoLiquidoCertificado = this.calcularTempoAfastamento(item.dtInicio, item.dtFim);
        itemIndexado.operacao = 0;
        return itemIndexado;
      });
    }

    if (ctcAtividade.temposCertificados && ctcAtividade.temposCertificados.length > 0) {
      ctcAtividade.temposCertificados.map((item) => {
        const itemIndexado = item;
        itemIndexado.nomeDestinacao = this.recuperarNomeDestinacao(item.indiceDestinatario);
        itemIndexado.tempoLiquidoCertificado = this.calcularTempoLiquidoCertificado(item.dtInicio, item.dtFim, true, ctcAtividade.afastamentos); 
        itemIndexado.operacao = 0;
        return itemIndexado;
      });
    }

    if (ctcAtividade.temposEspeciais && ctcAtividade.temposEspeciais.length > 0) {
      ctcAtividade.temposEspeciais.map((item) => {
        const itemIndexado = item;
        itemIndexado.tempoLiquidoCertificado = this.calcularTempoEspecial(item.dtInicio, item.dtFim);
        itemIndexado.operacao = 0;
        return itemIndexado;
      });
    }

    if (ctcAtividade.remuneracoes === null) {
      ctcAtividade.remuneracoes = [];
    }

    this.validarDatasInicioEFimAtividade(ctcAtividade);
    this.carregarListaDeAnosComRemuneracoes(ctcAtividade);
    this.atualizarValidadeCampos();

    this.setState({
      estadoFormulario: 'alterar',
      subEstadoFormulario: 'alterar-atividade',
      ctcAtividade,
      tituloBotao: 'salvar atividade',
      exibirBotaoIncluirInicial: false,
    }, () => this.showModalAtividade());
  }

  handleCarregarVisualizacaoAtividade = (row) => {
    let { atividades } = { ...this.props.statePrincipal.ctc };
    let ctcAtividade = {
      cnpj: atividades[row].cnpj,
      nomeEmpregador: atividades[row].nomeEmpregador,
      cargo: atividades[row].cargo,
      dtInicio: atividades[row].dtInicio,
      dtFim: atividades[row].dtFim,
      diasContribuicaoBruto: atividades[row].diasContribuicaoBruto,
      alunoAprendiz: atividades[row].alunoAprendiz,
      ctpsNumero: atividades[row].ctpsNumero,
      ctpsSerie: atividades[row].ctpsSerie,
      afastamentos: atividades[row].afastamentos,
      temposCertificados: atividades[row].temposCertificados,
      temposEspeciais: atividades[row].temposEspeciais,
      remuneracoes: atividades[row].remuneracoes,
      indice: atividades[row].indice,
      idAtividade: atividades[row].idAtividade,
      pertenceSegundaMatricula: atividades[row].pertenceSegundaMatricula,
    }

    if (ctcAtividade.afastamentos && ctcAtividade.afastamentos.length > 0) {
      ctcAtividade.afastamentos.map((item) => {
        const itemIndexado = item;
        itemIndexado.tempoLiquidoCertificado = this.calcularTempoAfastamento(item.dtInicio, item.dtFim);
        return itemIndexado;
      });
    }

    if (ctcAtividade.temposCertificados) {
      ctcAtividade.temposCertificados.map((item) => {
        const itemIndexado = item;
        itemIndexado.nomeDestinacao = this.recuperarNomeDestinacao(item.indiceDestinatario);
        itemIndexado.tempoLiquidoCertificado = this.calcularTempoLiquidoCertificado(item.dtInicio, item.dtFim, true, ctcAtividade.afastamentos);
        return itemIndexado;
      });
    }

    if (ctcAtividade.temposEspeciais && ctcAtividade.temposEspeciais.length > 0) {
      ctcAtividade.temposEspeciais.map((item) => {
        const itemIndexado = item;
        itemIndexado.tempoLiquidoCertificado = this.calcularTempoEspecial(item.dtInicio, item.dtFim);
        return itemIndexado;
      });
    }

    if(ctcAtividade.remuneracoes !== null && ctcAtividade.remuneracoes !== '') {
      ctcAtividade.remuneracoes = this.ordenarCompetenciasRemuneracao(ctcAtividade.remuneracoes);
    }

    this.setState({
      ctcAtividade,
      tituloBotao: 'salvar atividade',
      exibirBotaoIncluirInicial: false,
    }, () => this.showModalAtividade());
  }

  handleExcluirAtividade = (row) => {
    let { atividades, destinacoes } = { ...this.props.statePrincipal.ctc };
    let { linhasDestinacaoDesabilitar } = { ...this.props.statePrincipal };

    //habilitar o botao excluir da tela de destinatarios
    if ((atividades !== null && atividades !== undefined) && atividades.length > 0) {
      let atividadeCorrente = atividades[row];
      atividadeCorrente.temposCertificados.map((item) => {
        const itemIndexado = item;
        itemIndexado.operacao = 3;
        return itemIndexado;
      });

      // PESQUISAR O INDICE NA LISTA DE DESTINACOES UTILIZADAS NA LISTA DE TEMPOS CERTIFICADOS (linhasDestinacaoDesabilitar)
      destinacoes.forEach((destinacao) => {
        atividadeCorrente.temposCertificados.forEach((tempoCertificado) => {
          if (tempoCertificado.operacao === 3 && destinacao.nomeParticipante === tempoCertificado.nomeDestinacao) { // excluindo
            const index = linhasDestinacaoDesabilitar.findIndex(item => (item === destinacao.indice));
            if (index !== -1) {
              this.props.habilitarBotaoExcluirLinhaDestinacaoUtilizada(index);
            }
          } 
        });
      });
    }

    atividades.splice(row, 1);
    this.setState({
      exibirBotaoIncluirInicial: true,
    });
    this.resetarObjetoAtividade();
  }

  validarCheckboxSegundaMatricula = () => {
    let { ctc } = { ...this.props.statePrincipal };
    const { validadeCampos } = { ...this.state }
    const temMatricula1 = (ctc.matricula1 !== null && ctc.matricula1 !== VAZIO);
    const temMatricula2 = (ctc.matricula2 !== null && ctc.matricula2 !== VAZIO);

    if (temMatricula1 && !temMatricula2) {
      this.setState({
        ctc: {
          ...ctc,
          pertenceSegundaMatricula: 0,
        },
        validadeCampos: {
          ...validadeCampos,
          pertenceSegundaMatricula: true,
        },
      });
    }
  }

  verificarDesabilitarTodosOsBotoesAlterar = (desabilitar) => {
    const { ctc } = { ...this.props.statePrincipal };
    if (ctc.atividades && ctc.atividades.length > 0) {
      this.setState({
        desabilitarListaBotoes: desabilitar,
      });
    }
  }

  showModalAtividade = () => {
    const { ctc } = { ...this.props.statePrincipal };
    if (ctc.destinacoes && ctc.destinacoes.length > 0) {
      this.validarCheckboxSegundaMatricula();
      this.verificarDesabilitarTodosOsBotoesAlterar(true);
      this.validarDatasInicioEFimAtividade();
      this.setState({
        exibirBotaoIncluirInicial: false,
        showModal: !this.state.showModal
      });
    } else {
      trataMensagensErro(['É necessário possuir pelo menos um destinatário cadastrado para incluir uma atividade.']);
    }
  }

  handleCancelarAcao = () => {//testar a acao aqui para esconder o botao de incluir
    this.resetarObjetoAtividade();
    this.verificarDesabilitarTodosOsBotoesAlterar(false);
    this.setState({
      anosQuePossuemAlgumaRemuneracao: [],
      exibirBotaoIncluirInicial: (['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao)) ? false : true,
      showModal: !this.state.showModal,
    });
  }

  verificaSeCampoDesabilitado = (name) => {
    const { acao } = { ...this.props.statePrincipal };
    if (acao === 'detalhar-ctc' || acao === 'detalhar-ctc-invalida') {
      return true;
    }
    return false;
  };
  // dtinicioPeriodo | dtInicioAtv | dtfimAtv   | dtfimPeriodo
  // 01/01/1990      | 01/01/1991  | 01/01/1992 | 01/01/2000

  // const itemDatas = {
  //   'matricula': matriculaSelecionada,      
  //   'dtAdmissaoMat1': ctc.dtAdmissaoMat1,
  //   'dtAdmissaoMat2': ctc.dtAdmissaoMat2,
  //   'dtInicio': atividade.dtInicio,
  //   'dtFim': atividade.dtFim
  // };

  compararDatasAtividadeComPeriodoAtivoDaMatricula = (item) => {
    return ( moment(item.dtInicioAtividade, 'DD/MM/YYYY').toDate() >= moment(item.dtAdmissaoMatricula, 'DD/MM/YYYY').toDate() && 
    moment(item.dtFimAtividade, 'DD/MM/YYYY').toDate() <= moment(item.dtDemissaoMatricula, 'DD/MM/YYYY').toDate());
  }

  compararDatasInicio = (a, b) => {
    // Se compararDatasInicio(a, b) for menor que 0, ordena a para um índice anterior a b.
    // Se compararDatasInicio(a, b) retornar 0, deixa a e b inalterados em relação um ao outro, mas ordenado em relação a todos os outros elementos.
    // Se compararDatasInicio(a, b) é maior que 0, ordena b para um índice anterior que a.
    if (moment(a.dtInicio, 'DD/MM/YYYY').toDate() < moment(b.dtInicio, 'DD/MM/YYYY').toDate()) {
      return -1;
    }
    if (moment(a.dtInicio, 'DD/MM/YYYY').toDate() > moment(b.dtInicio, 'DD/MM/YYYY').toDate()) {
      return 1;
    }
    return 0;
  }

  compararCompetencias = (a, b) => {
    let a_mes = '';
    let a_ano = '';
    let b_mes = '';
    let b_ano = '';
    let a_mesInt = 0;
    let a_anoInt = 0;
    let b_mesInt = 0;
    let b_anoInt = 0;

    if (a && a.competencia && a.competencia !== null) {
      a_mes = a.competencia.split('-')[0];
      a_ano = a.competencia.split('-')[1];
  
      a_mesInt = parseInt(a_mes);
      a_anoInt = parseInt(a_ano);
    }
    if (b && b.competencia && b.competencia !== null) {
      b_mes = b.competencia.split('-')[0];
      b_ano = b.competencia.split('-')[1];

      b_mesInt = parseInt(b_mes);
      b_anoInt = parseInt(b_ano);
    }

    // let [a_mes, a_ano] = a.competencia ? [a.mes, a.ano].map(val => parseInt(val)): null;
    // let [b_mes, b_ano] = b.competencia ? [b.mes, b.ano].map(val => parseInt(val)): null;
    // primeiro compara o ano
    let cmp = a_anoInt - b_anoInt;
    if (cmp === 0) { // se o ano é igual, compara o mês
        cmp = a_mesInt - b_mesInt;
    }
    return cmp;
  }

  compararAnos = (a, b) => {
    let a_ano = '';
    let b_ano = '';
    let a_anoInt = 0;
    let b_anoInt = 0;

    if (a && a.ano && a.ano !== null) {
      a_ano = a.ano;
      a_anoInt = parseInt(a_ano);
    }
    if (b && b.ano && b.ano !== null) {
      b_ano = b.ano;
      b_anoInt = parseInt(b_ano);
    }

    //  compara o ano
    let cmp = a_anoInt - b_anoInt;
    return cmp;
  }

  compararCompetenciasRemuneracao = (a, b) => {
    let a_mes = '';
    let a_ano = '';
    let b_mes = '';
    let b_ano = '';
    let a_mesInt = 0;
    let a_anoInt = 0;
    let b_mesInt = 0;
    let b_anoInt = 0;

    if (a && a.mes && a.mes !== null && (a.ano && a.ano !== null)) {
      a_mes = a.mes;
      a_ano = a.ano;
  
      a_mesInt = (a_mes);
      a_anoInt = (a_ano);
    }
    if (b && (b.mes && b.mes !== null) && (b.ano && b.ano !== null)) {
      b_mes = b.mes;
      b_ano = b.ano;

      b_mesInt = (b_mes);
      b_anoInt = (b_ano);
    }

    // let [a_mes, a_ano] = a.competencia ? [a.mes, a.ano].map(val => parseInt(val)): null;
    // let [b_mes, b_ano] = b.competencia ? [b.mes, b.ano].map(val => parseInt(val)): null;
    // primeiro compara o ano
    let cmp = a_anoInt - b_anoInt;
    if (cmp === 0) { // se o ano é igual, compara o mês
        cmp = a_mesInt - b_mesInt;
    }
    return cmp;
  }

  compararMatricula = (a, b) => {
    let matricula1_a = '';
    let matricula1_b = '';

    if (a.matricula === '') {
      matricula1_a = '0';
    } else {
      matricula1_a = Number(a.matricula);
    }

    if (b.matricula === '') {
      matricula1_b = '0';
    } else {
      matricula1_b = Number(b.matricula);
    }

    if (matricula1_a < matricula1_b) {
      return -1;
    }
    if (matricula1_a > matricula1_b) {
      return 1;
    }
    return 0;
  }

  ordenarLista = (lista) => {
    lista.sort(this.compararDatasInicio);
    return lista;
  }

  ordenarListaRemuneracoes = (lista) => {
    lista.sort(this.compararCompetencias);
    return lista;
  }

  ordenarRemuneracoesPorAno = (lista) => {
    lista.sort(this.compararAnos);
    return lista;
  }

  ordenarCompetenciasRemuneracao = (lista) => {
    let retorno = [];
    if(lista !== null) {
      retorno = lista.sort(this.compararCompetenciasRemuneracao);
    }
    return retorno;
  }

  ordenarAtividadesPorMatriculaEDataInicio = (lista) => {
    let retorno = [];
    if(lista !== null) {
      retorno = lista.sort(this.compararDatasInicio);
      retorno = lista.sort(this.compararMatricula);
    }
    return retorno;
  }

  // ordenarAtividadesPorMatriculaEDataInicio = (lista) => {
  //   let retorno = [];
  //   if(lista !== null) {
  //     retorno = lista.sort(this.compararCompetenciasRemuneracao);
  //   }
  //   return retorno;
  // }

  validarTotalDiasBrutoAtividade(tempo, diaQtd) {
    let retorno = false;
    if(tempo > 0 && tempo >= diaQtd) {
      retorno = true;   
    } else {
      // trataMensagensErro(['O período é inválido. A quantidade de dias liquido deve ser maior que zero e menor que diferença entre a data de inicio e fim periodo.']);
      trataMensagensErro(['Tempo bruto inválido. A quantidade de dias do tempo bruto deve ser maior que zero e menor ou igual à diferença entre a data início e a data fim de atividade.']);      
    }
    return retorno ;
  }

  determinarNomeListaAtividades = () => {
    const id = this.props.id;
    let nomeLista = '';
    switch (id) {
      case 1:
        nomeLista = 'atividades';
        break;
      case 2:
        nomeLista = 'afastamentos';
        break;
      case 3:
        nomeLista = 'temposCertificados';
        break;
      case 4:
        nomeLista = 'temposEspeciais';
      break;
      case 5:
        nomeLista = 'remuneracoes';
      break;
      default:
        break;
    }
    return nomeLista;
  }

  formatarCompetencia = (competencia) => {
    let retorno = competencia;
    if (competencia.length !== 7) {
      retorno = `0${competencia}`;
    }
    return retorno;
  };

  verificarTotalAnosAtividade = (dtInicio, dtFim) => {
    let total = 0;
    if(dtFim !== null && dtInicio !== null) {
      let dataInicio = moment(dtInicio, 'DD/MM/YYYY').toDate();
      let dataFim = moment(dtFim, 'DD/MM/YYYY').toDate();

      total = Math.ceil((moment(dataFim).diff(dataInicio, 'years', true)));

      if (total > 0 && total > QTD_MAXIMA_ANOS_POR_ATIVIDADE) {
        trataMensagensErro([`O período máximo de tempo para uma atividade é de ${QTD_MAXIMA_ANOS_POR_ATIVIDADE} anos`]);
      } else {
        this.montarPlanilhaDeRemuneracoes(dtInicio, dtFim, total);
      }
    }
  }

  montarPlanilhaDeRemuneracoes = (dtInicio, dtFim, total) => {
    let remuneracoesAtividade = { totalizadorAnos: null, anos: [], moedasCompetencia: [], competenciasInicio: [] };
    let d1Ano = null;
    let d2Ano = null;
    let indiceInicioCompetencia = null;
    let indiceFimCompetencia = null;
    let dataInicioValidada = null;
    let totalValidado = 0;
    let competencias = [];
    // Moedas que mudaram antes do final do mês;
    // const listaCompetenciasEspeciais = ['02/1967', '05/1970', '01/1989', '03/1990'];
    // const listaCompetenciasInicio = ['09/1822', '11/1942', '02/1967', '05/1970', '02/1986', '01/1989', '03/1990', '08/1993', '07/1994'];
    const listaCompetenciasInicio = ['07/1994'];
    remuneracoesAtividade.competenciasInicio = listaCompetenciasInicio;

      if(moment(dtInicio, 'DD/MM/YYYY').toDate() < (moment(`01/${listaCompetenciasInicio[0]}`, 'DD/MM/YYYY').toDate())) {
        dataInicioValidada = `01/${listaCompetenciasInicio[0]}`;
        this.setState({ dataInicioAtividadeMenorQue1994: true, });
      } else {
        dataInicioValidada = dtInicio;
      }

      if(moment(dtFim, 'DD/MM/YYYY').toDate() < (moment(`01/${listaCompetenciasInicio[0]}`, 'DD/MM/YYYY').toDate())) {       
        this.setState({ dataFimAtividadeMenorQue1994: true, });
      } else {
        this.setState({ dataFimAtividadeMenorQue1994: false, });
      }

      if (dataInicioValidada !== dtInicio) {
        let d1 = moment(dataInicioValidada, 'DD/MM/YYYY').toDate();
        let d2 = moment(dtFim, 'DD/MM/YYYY').toDate();

        totalValidado = Math.ceil((moment(d2).diff(moment(d1), 'years', true)));
        remuneracoesAtividade.totalizadorAnos = totalValidado;
      }else{
        remuneracoesAtividade.totalizadorAnos = total;
      }

      d1Ano = parseInt(dataInicioValidada.substring(6, 10), 10);
      d2Ano = parseInt(dtFim.substring(6, 10), 10);
      indiceInicioCompetencia = (parseInt(dataInicioValidada.substring(3, 5), 10) - 1);
      indiceFimCompetencia = (parseInt(dtFim.substring(3, 5), 10) - 1);
      
      for (let index = d1Ano; index <= d2Ano; index++) {
        remuneracoesAtividade.anos.push(index);
      }
      remuneracoesAtividade.anos.forEach((ano) => {
        let indiceInicio = 0;
        let indiceFim = 12;
        //primeiro
        if (remuneracoesAtividade.anos[0] === ano) {
          indiceInicio = indiceInicioCompetencia;
        }
        //ultimo
        if (remuneracoesAtividade.anos[remuneracoesAtividade.anos.length-1] === ano) {
          indiceFim = indiceFimCompetencia;
        }
        for (let index = indiceInicio; index <= indiceFim; index++) {
          let competenciaFormat = `${listUtils.getObjectByIndex(listUtils.meses, index).label} / ${ano}`;
          let competenciaCriada = `${index+1}/${ano}`;
          let objCompetencia = {anoAtividade: ano, competencia: this.formatarCompetencia(competenciaCriada), competenciaFormatada: competenciaFormat };
          competencias.push(objCompetencia);
        }
      });

      let listaMoedasUtilizadas = [];
      listUtils.periodosMoedasBrasileiras.forEach((periodo) => {
        const dataInicio = dataInicio !== null ? moment(dataInicioValidada, 'DD/MM/YYYY').toDate(): null;
        const dataFim = dataFim !== null ? moment(dtFim, 'DD/MM/YYYY').toDate(): null;
        const dataInicioPeriodo = periodo.dataInicio !== null ? moment(periodo.dataInicio, 'DD/MM/YYYY').toDate(): null;
        const dataFimPeriodo = periodo.dataFim !== null ? moment(periodo.dataFim, 'DD/MM/YYYY').toDate(): null;

        if((dataInicio <= dataFimPeriodo && dataFim > dataInicioPeriodo) || (dataFim !== null && dataFimPeriodo === null)) {
          const inicio = moment(dataInicioPeriodo).format('DD/MM/YYYY');
          const fim = dataFimPeriodo !== null ? moment(dataFimPeriodo).format('DD/MM/YYYY') : null;
          let moeda = { value: periodo.codigo, label: periodo.sigla, dataInicioValidada: inicio, dtFim: fim};
          listaMoedasUtilizadas.push(moeda);
        }
      });
      /*
      Cód. moeda	Sigla	  Descrição	    Valor de conversão	Data ínicio	Data fim
      9	            R$	  REAL	        2750	              01/07/1994	----
      8	            CR$	  CRUZEIRO REAL	1000	              01/08/1993	30/06/1994
      7	            Cr$	  CRUZEIRO	    1	                  16/03/1990	31/07/1993
      6	            NCz$	CRUZADO NOVO	1000	              16/01/1989	15/03/1990
      5	            Cz$	  CRUZADO	      1000	              28/02/1986	15/01/1989
      4	            Cr$	  CRUZEIRO	    1	                  15/05/1970	27/02/1986
      3	            NCr$	CRUZEIRO NOVO	1000	              13/02/1967	14/05/1970
      2	            Cr$	  CRUZEIRO	    1	                  01/11/1942	12/02/1967
      1	            RS$	  MIL REIS      1	                  07/09/1822	31/10/1942

      dataInicio = 01/01/1990
      dataFim    = 01/01/2000
      */
      let moedaCompetencia = null;
      let moedaCompetencia13 = null;
      let moedaUtilizada= null;

      competencias.forEach((item) => {
        let dataInicioCompetencia = null;
        if (parseInt(item.competencia.substring(0, 2), 10) !== 13) {
          dataInicioCompetencia = moment(`01/${item.competencia}`, 'DD/MM/YYYY').toDate();
        }
        // nao é o ultimo item da colecao
        // && (item.competencia != competencias[competencias.length-1].competencia)
        if (dataInicioCompetencia !== null) {
          let indexMoeda =
          listaMoedasUtilizadas.findIndex(moeda =>
            (dataInicioCompetencia <= (moment(moeda.dtFim, 'DD/MM/YYYY').toDate()) ||
            dataInicioCompetencia <= (moment(moeda.dataInicioValidada, 'DD/MM/YYYY').toDate())) &&
            (dataInicioCompetencia <= (moment(moeda.dtFim, 'DD/MM/YYYY').toDate())) ||
            (moeda.dtFim === null));

          if (indexMoeda !== -1) {
            let siglaMoeda = '';
            let tipo = '';

            /*if(listaCompetenciasEspeciais.includes(item.competencia)) {
              siglaMoeda = (listaMoedasUtilizadas[indexMoeda+1]).label;
              tipo = (listaMoedasUtilizadas[indexMoeda+1]).value;
            } else {*/
            siglaMoeda = (listaMoedasUtilizadas[indexMoeda]).label;
            tipo = (listaMoedasUtilizadas[indexMoeda]).value;
            // }
            moedaCompetencia = {
              competencia: item.competencia,
              competenciaFormatada: item.competenciaFormatada,
              sigla: siglaMoeda,
              ano: parseInt(item.competencia.substring(3, 7), 10),
              tipoMoeda: tipo,
            };
            moedaUtilizada = moedaCompetencia;
          }
        } else {
          let competencia13 = `12/${item.competencia.substring(3, 7)}`;
          let indexMoeda13 = remuneracoesAtividade.moedasCompetencia.findIndex(moeda => (competencia13 === moeda.competencia));
          if (indexMoeda13 !== -1) {
            moedaCompetencia13 = {
              competencia: item.competencia,
              competenciaFormatada: item.competenciaFormatada,
              sigla: (remuneracoesAtividade.moedasCompetencia[indexMoeda13]).sigla,
              ano: parseInt(item.competencia.substring(3, 7), 10),
              tipoMoeda: (remuneracoesAtividade.moedasCompetencia[indexMoeda13]).tipoMoeda,
            };
              moedaUtilizada = moedaCompetencia13;
            }
          }
          remuneracoesAtividade.moedasCompetencia.push(moedaUtilizada);

          if (dataInicioCompetencia !== null && (item.competencia === competencias[competencias.length-1].competencia)) {
            let indexMoeda13 = remuneracoesAtividade.moedasCompetencia.findIndex(moeda => (item.competencia === moeda.competencia));
            if (indexMoeda13 !== -1) {
              moedaCompetencia13 = {
                competencia: `13/${item.competencia.substring(3, 7)}`,
                competenciaFormatada: `13º/${item.competencia.substring(3, 7)}`,
                sigla: (remuneracoesAtividade.moedasCompetencia[indexMoeda13]).sigla,
                ano: parseInt(item.competencia.substring(3, 7), 10),
                tipoMoeda: (remuneracoesAtividade.moedasCompetencia[indexMoeda13]).tipoMoeda,
              };
                moedaUtilizada = moedaCompetencia13;
            }
            remuneracoesAtividade.moedasCompetencia.push(moedaUtilizada);
          }  
      });
    this.setState({ remuneracoesAtividade });
  // }
  }

  montaFormularioDadosCnpj = (response) => {
    const { ctcAtividade } = { ...this.state };
    const { requestPesquisa } = { ...this.state };   

    const nomeEmpresa = response.data.nome;
    if (nomeEmpresa !== null && nomeEmpresa !== '' && nomeEmpresa !== undefined) {
      ctcAtividade[requestPesquisa] = nomeEmpresa;
    }

    this.setState({
      [requestPesquisa]: nomeEmpresa,
    });
  }

  trataSucessoResponsePesquisaCnpj = (response) => {
    this.montaFormularioDadosCnpj(response);
  }

  trataErrosResponse = (error) => {
    if (error) {
      if (error.status === 404) {
        console.log('erro 404');
      }
    }
  }

  handleSearchCNPJ = (nome, cnpj) => {
    this.setState(
      { requestPesquisa: nome },
      doGet(
        `pessoas-juridicas/${cnpj}`,
        this.trataSucessoResponsePesquisaCnpj,
        this.trataErrosResponse,
      ),
    );
  }

  handleSearchCnpjButton = (nome, cnpj) => {
    if (cnpj !== null && cnpj !== '') {
      this.setState(this.handleSearchCNPJ(nome, cnpj));
    } else {
      trataMensagensErro(['CNPJ inválido. Informe um CNPJ válido.']);
    }
  }

  render () {
    return (
      <div>
        <MultiplasAtividades
          id={1}
          statePrincipal={this.props.statePrincipal}
          ctcAtividade={this.state.ctcAtividade}
          handleChange={this.handleChange}
          titulo='Atividades'
          retirarLinhaSeparadora={false}
          handleCarregarAlteracaoAtividade={this.handleCarregarAlteracaoAtividade}
          ordenarLista={this.ordenarLista}
          handleExcluirAtividade={this.handleExcluirAtividade}
          handleCarregarVisualizacaoAtividade={this.handleCarregarVisualizacaoAtividade}
          validarCheckboxSegundaMatricula={this.validarCheckboxSegundaMatricula}
          verificarDesabilitarTodosOsBotoesAlterar={this.verificarDesabilitarTodosOsBotoesAlterar}
          validarDatasInicioEFimAtividade={this.validarDatasInicioEFimAtividade}
          stateAtividade={this.state}
          ordenarAtividadesPorMatriculaEDataInicio={this.ordenarAtividadesPorMatriculaEDataInicio}
          determinarConcomitancias={this.determinarConcomitancias}
        />
        { this.state.showModal ? (
          <ModalAtividade
            {...this.props}
            className="modal-atividades"
            style={{ height: '480rem', 'overflow-y': 'auto', 'overflow-x': 'hidden', padding: '1rem' }}
            compararDatasInicio={this.compararDatasInicio}
            ordenarLista={this.ordenarLista}
            ordenarListaRemuneracoes={this.ordenarListaRemuneracoes}
            ordenarRemuneracoesPorAno={this.ordenarRemuneracoesPorAno}
            ordenarCompetenciasRemuneracao={this.ordenarCompetenciasRemuneracao}
            resetarObjetoAtividade={this.resetarObjetoAtividade}
            calcularDiasContribuicaoBrutoAtividade={this.calcularDiasContribuicaoBrutoAtividade}
            validarDatasInicioEFimAtividade={this.validarDatasInicioEFimAtividade}
            determinarNomeListaAtividades={this.determinarNomeListaAtividades}
            desabilitarCheckboxMatriculaEDestinacao={this.props.desabilitarCheckboxMatriculaEDestinacao}
            habilitarCheckboxMatriculaEDestinacao={this.props.habilitarCheckboxMatriculaEDestinacao}
            desabilitarBotaoExcluirLinhaDestinacaoUtilizada={this.props.desabilitarBotaoExcluirLinhaDestinacaoUtilizada}
            habilitarBotaoExcluirLinhaDestinacaoUtilizada={this.props.habilitarBotaoExcluirLinhaDestinacaoUtilizada}
            verificarDestinacaoSelecionadaAtividade={this.props.verificarDestinacaoSelecionadaAtividade}
            ctcAtividade={this.state.ctcAtividade}
            showModal={this.state.showModal}
            estadoFormulario={this.props.estadoFormulario}
            stateAtividade={this.state}
            handleCancelarAcao={this.handleCancelarAcao}
            handleChangeCtcAtividade={this.handleChange}
            handleManterAtividade={this.handleManterAtividade}
            handleExcluirAtividade={this.handleExcluirAtividade}
            montarListaDestinacaoTempoCertificado={this.props.montarListaDestinacaoTempoCertificado}
            handleSearchCnpjButton={this.handleSearchCnpjButton}
            ordenarAtividadesPorMatriculaEDataInicio={this.ordenarAtividadesPorMatriculaEDataInicio}
            calcularTempoLiquidoCertificado={this.calcularTempoLiquidoCertificado}
            calcularTempoAfastamento={this.calcularTempoAfastamento}
            calcularTempoEspecial={this.calcularTempoEspecial}
            verificarMudancaTempoLiquidoCertificado={this.verificarMudancaTempoLiquidoCertificado}
            validarCheckboxSegundaMatricula={this.validarCheckboxSegundaMatricula}
            limparValidadeCampos={this.limparValidadeCampos}
          />
        ) : ''}
      </div>
    );
  }
};

CtcAtividade.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  controlarExibicaoPainelAtividade: PropTypes.func.isRequired,
  validarPeriodoTempoCertificado: PropTypes.func.isRequired,
  verificarDestinacaoSelecionadaAtividade: PropTypes.func.isRequired,
  desabilitarCheckboxMatriculaEDestinacao: PropTypes.func.isRequired,
  habilitarCheckboxMatriculaEDestinacao: PropTypes.func.isRequired,
  desabilitarBotaoExcluirLinhaDestinacaoUtilizada: PropTypes.func.isRequired,
  habilitarBotaoExcluirLinhaDestinacaoUtilizada: PropTypes.func.isRequired,
  montarListaDestinacaoTempoCertificado: PropTypes.func.isRequired,
};
export default CtcAtividade;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/CtcAtividade.jsx